import moment from 'moment';

const formatTime = time => {
  let timeEntityCount = 0;
  let hours, mins, secs;
  if (time === '00:00:00') return '0 minute';

  const minPrepTime = time.split(':');

  if (minPrepTime[0] > 0) {
    timeEntityCount++;
    hours = parseInt(minPrepTime[0]);
  }
  if (minPrepTime[1] > 0) {
    timeEntityCount++;
    mins = parseInt(minPrepTime[1]);
  }
  if (minPrepTime[2] > 0) {
    timeEntityCount++;
    secs = parseInt(minPrepTime[2]);
  }

  const prepTimeInMin =
    timeEntityCount > 1
      ? `${hours ? hours + 'hr ' : ''}${mins ? mins + 'min ' : ''}${
          secs ? secs + 'sec' : ''
        }`
      : `${hours ? hours + (hours > 1 ? ' hours' : ' hour') : ''}${
          mins ? mins + (mins > 1 ? ' minutes' : ' minute') : ''
        }${secs ? secs + (secs > 1 ? ' seconds' : ' second') : ''}`;

  return prepTimeInMin;
};

export const getWeekdaysFromToday = () => {
  let day = moment();
  const newArray = [];
  for (let i = 0; i < 7; i++) {
    newArray.push(day.format('dddd').toLowerCase());
    day = day.add(1, 'days');
  }
  return newArray;
};

export const getDayToday = () => {
  return moment()
    .format('dddd')
    .toLowerCase();
};

export default formatTime;
